<template>
  <div>
    <md-dialog :md-active="showDialog" id="dlg-import-product-excel" md-height="100%" @md-opened="onDialogOpen">
      <md-dialog-title>Import customer.</md-dialog-title>
      <!-- {{dataExcel}} -->
      <md-dialog-content>
        <div v-show="listData.length ==0">Not found customer code to import.</div>
        <md-table
          md-height="100%"
          v-model="listData"
          md-sort="name"
          md-sort-order="asc"
          md-card
          md-fixed-header
          v-show="listData.length > 0"
        >
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell md-label="Customer BPCode" v-html="checkLifecycle(item)"></md-table-cell>
            <md-table-cell md-label="Customer Name Thai">{{ item.title_th }}</md-table-cell>
            <md-table-cell md-label="">{{ item.status }}</md-table-cell>
          </md-table-row>
        </md-table>

      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary btn-close" @click="cancel">Close</md-button>
        <md-button class="md-primary btn-import" @click="ImportCustomer">Import</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>

import ProductService from "@/services/product";

export default {
  name: "import-product-excel",
  props: ["showDialog", "dataExcel", "importedProduct", "customers"],
  data() {
    return {
      listData: []
    };
  },
  computed:{
    // listItem(){
    //   return this.dataExcel;
    // }
  },
  created() {

    // console.log(this.listData);
    // this.listData = this.cstomers;
  },
  methods: {
    onDialogOpen(){

      
      // console.log(this.customers)
        // console.log(this.products)
      this.listData = [];
      this.dataExcel.forEach(item => {

        let idx = this.customers.findIndex(x => x.code === item);
        if(idx > -1) {
          this.listData.push({code:this.customers[idx].code,title_th:this.customers[idx].title_th,status:""});
        }else{
          this.listData.push({code:item,title_th:"",status:"Item not found"});
        }
      });

      console.log(this.listData);
    },
    cancel() {
      this.$emit("onCancel", false);
    },
    checkLifecycle(item) {
      if (item.status == "Item not found") {
        return (
          "<span style='margin-left:20px;color:red'>" + item.code + "</span>"
        );
      } else {
        return "<span style='margin-left:20px;'>" + item.code + "</span>";
      }
    },
    isDupProduct(code) {
      for (let i = 0; i < this.importedProduct.length; i++) {
        if (this.importedProduct[i].code == code) return true;
      }
      return false;
    },
    ImportCustomer() {
      // let products = this.products.filter(prod => {
      //   return prod.productlifecycle_code != "none";
      // });
      // let prod = products.reduce(function(pV, cV) {
      //   pV.push(cV.code);
      //   return pV;
      // }, []);

      let customers = this.customers;

      this.$emit('onImport', customers)
    //   this.searchProductByCode(prod);
    },
    showLifeCycle(code) {
      let lifecycle = ["41", "42", "43", "44", "45", "51", "52", "53", "54"];
      if (lifecycle.includes(code)) return code;
    }
  }
};
</script>

<style lang="scss" scoped>
#dlg-import-product-excel {
  width: 60%;

  .btn-close {
    color: black;
  }
  .btn-import {
    color: black;
    margin-right: 20px;
  }
}

.md-card {
  box-shadow: none;
}
.md-table {
  border: 0px !important;
  height: calc(100vh - 350px);
}
.md-table-row .md-table-cell {
  border: 0px !important;
}
.md-table-fixed-header {
  border: 0px !important;
}
.md-table-content {
  border: 0px !important;
}
</style>

